import {
  Flex,
  Timeline,
} from "@components/index";
import { useGanttDataContext } from "@pages/Dashboard/contexts/GanttData.context";
import styles from "../Gantt.module.scss";
import timelineStyles from "@common/components/internal/Timeline/Timeline.module.scss";

interface GanttGerencialProps {
  day: string;
}

const GanttGerencial: React.FC<GanttGerencialProps> = ({ day }) => {
  const { mapGroupD1 = [], mapGroupD2 = [] } = useGanttDataContext();

  const startD1 = new Date(`${day}T07:00:00`);
  const endD1 = new Date(`${day}T15:00:00`);
  const startD2 = new Date(`${day}T14:30:00`);
  const endD2 = new Date(`${day}T23:00:00`);

  return (
    <Flex.Col className={styles.content}>
      <Timeline
        height="60%"
        start={startD1}
        end={endD1}
        groups={mapGroupD1}
        overlapEnd={startD2}
        className={timelineStyles["timeline-gerencial"]}
      />
      <Timeline
        height="40%"
        start={startD2}
        end={endD2}
        groups={mapGroupD2}
        className={timelineStyles["timeline-gerencial"]}
      />
    </Flex.Col>
  );
};

export default GanttGerencial;
